function checkForUpdates() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistration().then(registration => {
      if (registration) {
        registration.update()
          .then(() => {
            console.log('Checked for updates')
          })
          .catch(error => {
            console.error('Error checking for updates:', error)
          })
      }
    })
  }
}

function setupPWAAutoUpdate(period: number) {
  // Check for updates
  setInterval(checkForUpdates, period)

  // Listen for the 'controllerchange' event, which fires when a new service worker takes over
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    console.log('New service worker activated, reloading for latest version')
    location.reload()
  })
}

export function usePwa() {
  return {
    setupPWAAutoUpdate
  };
}
